import { useQuery } from '@tanstack/react-query';

import { StudioService } from '../../services';
import { queryKeys } from '../keys';

const STUDIO_STALE_MS = 5 * 60 * 1000;

export function useLabs() {
  return useQuery({
    queryKey: queryKeys.labs,
    queryFn: () => StudioService.listLabs(),
    staleTime: STUDIO_STALE_MS,
  });
}

export function useLab(labId: string | undefined) {
  return useQuery({
    queryKey: queryKeys.lab(labId ?? ''),
    queryFn: () => StudioService.getLab(labId!),
    enabled: !!labId,
    staleTime: STUDIO_STALE_MS,
  });
}

export function useStudios(labId?: string) {
  return useQuery({
    queryKey: queryKeys.studios(labId),
    queryFn: () => StudioService.listStudios(labId),
    staleTime: STUDIO_STALE_MS,
  });
}

export function useStudio(studioId: string | undefined) {
  return useQuery({
    queryKey: queryKeys.studio(studioId ?? ''),
    queryFn: () => StudioService.getStudio(studioId!),
    enabled: !!studioId,
    staleTime: STUDIO_STALE_MS,
  });
}
